export const datakatalogTabChannelName = (token: string) =>
    `vegkart-datakatalog-${token}`;

export const isVSCodeIntegratedBrowser = (userAgent: string) =>
    /\bCode\/[\d.]+/.test(userAgent) && /\bElectron\/[\d.]+/.test(userAgent);

export const DATAKATALOG_WINDOW_FEATURES =
    'width=1400,height=900,scrollbars=yes,resizable=yes,menubar=no,toolbar=no,location=no,status=no';

// Selve Window-objektet sendes ikke som prop, fordi React sin utviklingslogging av props
// da prøver å lese Datakatalog-iframen på et annet opphav og kaster SecurityError.
export interface DatakatalogWindowHandle {
    isClosed: () => boolean;
    close: () => void;
}

export const createDatakatalogWindowHandle = (
    openedWindow: Window
): DatakatalogWindowHandle => ({
    isClosed: () => openedWindow.closed,
    close: () => {
        if (!openedWindow.closed) openedWindow.close();
    },
});

export interface DatakatalogWindowLauncher {
    url: string;
    // I VS Code åpnes fanen via en vanlig lenke; ellers via window.open i klikket.
    asLink: boolean;
    label: string;
    pendingLabel: string;
    onOpen: () => void;
}

export const createDatakatalogTabUrl = (
    currentUrl: string,
    token: string,
    src: string
) => {
    const url = new URL(currentUrl);
    url.hash = '';
    url.searchParams.set('datakatalogTab', token);
    url.searchParams.set('datakatalogSrc', src);
    return url.href;
};

export type DatakatalogTabMessage =
    | { type: 'ADD_VEGOBJEKT_FROM_DATAKATALOG'; payload: unknown }
    | { type: 'READY' }
    | { type: 'OPEN_INLINE' }
    | { type: 'CLOSE' }
    | { type: 'CLOSE_TAB' }
    | { type: 'TAB_UNLOADED' }
    | { type: 'PING' }
    | { type: 'DISCONNECT' };

export const isDatakatalogTabMessage = (
    value: unknown
): value is DatakatalogTabMessage => {
    if (value === null || typeof value !== 'object' || !('type' in value)) {
        return false;
    }

    switch (value.type) {
        case 'ADD_VEGOBJEKT_FROM_DATAKATALOG':
            return 'payload' in value;
        case 'READY':
        case 'OPEN_INLINE':
        case 'CLOSE':
        case 'CLOSE_TAB':
        case 'TAB_UNLOADED':
        case 'PING':
        case 'DISCONNECT':
            return true;
        default:
            return false;
    }
};
